<template>
  <!-- 事件信息 -->
  <div class="eventInfo-block">
    <div v-if="eventValue == 'cancerDiseaseInfo'" class="item-input flex">
      <div class="operate-block label-block flex">
        <p class="label-title">{{ isCaseType ? "疾病名称" : "诊断名称" }}：</p>
        <el-autocomplete
          v-model="icdName"
          class="input-block"
          placeholder="请输入疾病名称"
          :fetch-suggestions="querySearch_front"
          :trigger-on-focus="false"
          @select="handleSelect"
        />
      </div>
      <div class="operate-block label-block flex">
        <p class="label-title">ICD10：</p>
        <el-input
          v-model="icdCode"
          disabled
          placeholder="请输入内容"
          class="input-block"
        />
      </div>
    </div>

    <!-- 抗癌-会员首次确诊时间及发病时间 -->
    <div v-if="eventValue == 'cancerTime'" class="item-input flex">
      <div class="operate-block label-block flex">
        <p class="label-title">确诊时间：</p>
        <el-date-picker
          v-model="firstDiagnosisTime"
          align="right"
          type="date"
          placeholder="请选择日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          :disabled="!isEditStatus"
          @change="(value) => onChangeInputVal('firstDiagnosisTime', value)"
        />
      </div>
      <div class="operate-block label-block flex">
        <p class="label-title grey sTitle" v-html="areReported" />
      </div>
      <div class="operate-block label-block flex">
        <p class="label-title">发病时间：</p>
        <el-date-picker
          v-model="symptomAppearanceTime"
          align="right"
          type="date"
          placeholder="请选择日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          :disabled="!isEditStatus"
          @change="(value) => onChangeInputVal('symptomAppearanceTime', value)"
        />
      </div>
    </div>

    <!-- 意外-会员事故时间及死亡时间 -->
    <div v-if="eventValue == 'accidentTime'" class="item-input flex">
      <div class="operate-block label-block flex">
        <p class="label-title">事故时间：</p>
        <el-date-picker
          v-model="accidentTime"
          align="right"
          type="date"
          placeholder="请选择日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          :disabled="!isEditStatus"
          @change="(value) => onChangeInputVal('accidentTime', value)"
        />
      </div>
      <div class="operate-block label-block flex">
        <p class="label-title">死亡/走失时间：</p>
        <el-date-picker
          v-model="memberDeathTime"
          align="right"
          type="date"
          placeholder="请选择日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          :disabled="!isEditStatus"
          @change="(value) => onChangeInputVal('memberDeathTime', value)"
        />
      </div>
      <div class="operate-block label-block flex">
        <p class="label-title grey sTitle" v-html="areReported" />
      </div>
    </div>

    <div v-if="eventValue == 'tnmInfo'" class="item-input flex">
      <div class="operate-block label-block flex">
        <p class="label-title">TNM分期：</p>
        <el-cascader
          ref="tnm"
          v-model="tnmName"
          :options="tnmTreeList"
          :props="tnmProps"
          placeholder="请选择"
          :show-all-levels="false"
          @change="onChangeTnmVal"
        />
      </div>
    </div>

    <!-- 生活轨迹 -->
    <div v-if="eventValue == 'lifeTrack'" class="item-input flex">
      <el-select
        v-model="lifeTrack"
        placeholder="请选择"
        class="operate-block select-block"
        :disabled="!isEditStatus"
        @change="(value) => onChangeInputVal('lifeTrack', value)"
      >
        <el-option
          v-for="(item, index) in allLifeTrack"
          :key="index"
          :label="item.name"
          :value="item.code"
        />
      </el-select>
    </div>

    <!-- 第三方保险/互助累计保额大于100万 -->
    <div v-if="eventValue == 'thirdPartyInsurance'" class="item-input flex">
      <el-select
        v-model="thirdPartyInsurance"
        placeholder="请选择"
        class="operate-block select-block"
        :disabled="!isEditStatus"
        @change="(value) => onChangeInputVal('thirdPartyInsurance', value)"
      >
        <el-option
          v-for="(item, index) in allThirdPartyInsurance"
          :key="index"
          :label="item.name"
          :value="item.code"
        />
      </el-select>
    </div>

    <!-- 健康风险隐瞒 -->
    <div v-if="eventValue == 'hiddenDiseaseHistory'" class="item-input flex">
      <el-select
        v-model="hiddenDiseaseHistory"
        placeholder="请选择"
        class="operate-block select-block"
        :disabled="!isEditStatus"
        @change="(value) => onChangeInputVal('hiddenDiseaseHistory', value)"
      >
        <el-option
          v-for="(item, index) in allHiddenDiseaseHistory"
          :key="index"
          :label="item.name"
          :value="item.code"
        />
      </el-select>
    </div>

    <!-- 职业欺诈 -->
    <div v-if="eventValue == 'riskAppend'" class="item-input flex">
      <el-select
        v-model="riskAppend"
        placeholder="请选择"
        class="operate-block select-block"
        :disabled="!isEditStatus"
        @change="(value) => onChangeInputVal('riskAppend', value)"
      >
        <el-option
          v-for="(item, index) in allRiskAppend"
          :key="index"
          :label="item.name"
          :value="item.code"
        />
      </el-select>
    </div>

    <!-- 事故类型 -->
    <div v-if="eventValue == 'accidentType'" class="item-input flex">
      <div class="operate-block label-block flex">
        <p class="label-title">事故类型：</p>
        <el-select
          v-model="accidentTypeName"
          placeholder="请选择"
          :disabled="!isEditStatus"
          @change="accidentTypeChange"
        >
          <el-option
            v-for="(item, index) in accidentTypeList"
            :key="index"
            :label="item.name"
            :value="item.code"
          />
        </el-select>
      </div>
    </div>

    <!-- 是否高风险运动 -->
    <div v-if="eventValue == 'isRiskMovement'" class="item-input flex">
      <div class="operate-block label-block">
        <el-select
          v-model="isRiskMovement"
          placeholder="请选择"
          :disabled="!isEditStatus"
          @change="(value) => onChangeInputVal('isRiskMovement', value)"
        >
          <el-option
            v-for="(item, index) in isType"
            :key="index"
            :label="item.name"
            :value="item.code"
          />
        </el-select>
      </div>
      <div v-if="isRiskMovement == 1" class="operate-block label-block">
        <el-select
          v-model="riskMovement"
          placeholder="请选择"
          :disabled="!isEditStatus"
          @change="(value) => onChangeInputVal('riskMovement', value)"
        >
          <el-option
            v-for="(item, index) in riskMovementType"
            :key="index"
            :label="item.name"
            :value="item.code"
          />
        </el-select>
      </div>
      <div v-if="riskMovement == 22" class="operate-block label-block flex">
        <p class="label-title">具体描述：</p>
        <el-input
          v-model="riskMovementRemark"
          placeholder="请填写具体描述"
          @change="(value) => onChangeInputVal('riskMovementRemark', value)"
        />
      </div>
    </div>

    <!-- 是否高风险职业 -->
    <div v-if="eventValue == 'isRiskJob'" class="item-input flex">
      <div class="operate-block label-block">
        <el-select
          v-model="isRiskJob"
          placeholder="请选择"
          :disabled="!isEditStatus"
          @change="(value) => onChangeInputVal('isRiskJob', value)"
        >
          <el-option
            v-for="(item, index) in isType"
            :key="index"
            :label="item.name"
            :value="item.code"
          />
        </el-select>
      </div>
      <div v-if="isRiskJob == 1" class="operate-block label-block">
        <el-select
          v-model="riskJob"
          placeholder="请选择"
          :disabled="!isEditStatus"
          @change="(value) => onChangeInputVal('riskJob', value)"
        >
          <el-option
            v-for="(item, index) in riskJobType"
            :key="index"
            :label="item.name"
            :value="item.code"
          />
        </el-select>
      </div>
    </div>

    <!-- 是否高风险作业 -->
    <div v-if="eventValue == 'isRiskTask'" class="item-input flex">
      <div class="operate-block label-block">
        <el-select
          v-model="isRiskTask"
          placeholder="请选择"
          :disabled="!isEditStatus"
          @change="(value) => onChangeInputVal('isRiskTask', value)"
        >
          <el-option
            v-for="(item, index) in isType"
            :key="index"
            :label="item.name"
            :value="item.code"
          />
        </el-select>
      </div>
      <div v-if="isRiskTask == 1" class="operate-block label-block">
        <el-select
          v-model="riskTask"
          placeholder="请选择"
          :disabled="!isEditStatus"
          @change="(value) => onChangeInputVal('riskTask', value)"
        >
          <el-option
            v-for="(item, index) in riskTaskType"
            :key="index"
            :label="item.name"
            :value="item.code"
          />
        </el-select>
      </div>
      <div v-if="isRiskTask == 1" class="operate-block label-block flex">
        <p class="label-title">具体描述：</p>
        <el-input
          v-model="riskTaskRemark"
          placeholder="请填写具体描述"
          @change="(value) => onChangeInputVal('riskTaskRemark', value)"
        />
      </div>
    </div>

    <!-- 意外互助标准 -->
    <div v-if="eventValue == 'ywMutualStandard'" class="item-input flex">
      <el-select
        v-model="ywMutualStandard"
        placeholder="请选择"
        class="operate-block select-block"
        :disabled="!isEditStatus"
        @change="(value) => onChangeInputVal('ywMutualStandard', value)"
      >
        <el-option
          v-for="(item, index) in ywhzType"
          :key="index"
          :label="item.name"
          :value="item.code"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import NP from 'number-precision' // 使用js精确地执行加法、减法、乘法和除法运算

export default {
  name: 'EventInfo',

  props: {
    // 事件信息的类型
    eventValue: {
      type: String,
      default: () => {
        return ''
      }
    }
  },

  data() {
    return {
      icdName: '', // 疾病名称
      nginxServerData: [], // 疾病名称-建议列表
      icdCode: '', // ICD
      firstDiagnosisTime: '', // 确诊时间
      symptomAppearanceTime: '', // 发病时间
      accidentTime: '', // 事故时间
      memberDeathTime: '', // 死亡时间
      // TNM分期
      tnmList: [
        { code: 100000, name: 'TX', parentCode: 0 },
        { code: 100100, name: 'NX', parentCode: 100000 },
        { code: 100101, name: 'TXNXM0', parentCode: 100100 },
        { code: 100102, name: 'TXNXM1', parentCode: 100100 },
        { code: 100200, name: 'N0', parentCode: 100000 },
        { code: 100201, name: 'TXN0M0', parentCode: 100200 },
        { code: 100202, name: 'TXN0M1', parentCode: 100200 },
        { code: 100300, name: 'N1', parentCode: 100000 },
        { code: 100301, name: 'TXN1M0', parentCode: 100300 },
        { code: 100302, name: 'TXN1M1', parentCode: 100300 },
        { code: 100400, name: 'N2', parentCode: 100000 },
        { code: 100401, name: 'TXN2M0', parentCode: 100400 },
        { code: 100402, name: 'TXN2M1', parentCode: 100400 },
        { code: 100500, name: 'N3', parentCode: 100000 },
        { code: 100501, name: 'TXN3M0', parentCode: 100500 },
        { code: 100502, name: 'TXN3M1', parentCode: 100500 },

        { code: 110000, name: 'T0', parentCode: 0 },
        { code: 110100, name: 'NX', parentCode: 110000 },
        { code: 110101, name: 'T0NXM0', parentCode: 110100 },
        { code: 110102, name: 'T0NXM1', parentCode: 110100 },
        { code: 110200, name: 'N0', parentCode: 110000 },
        { code: 110201, name: 'T0N0M0', parentCode: 110200 },
        { code: 110202, name: 'T0N0M1', parentCode: 110200 },
        { code: 110300, name: 'N1', parentCode: 110000 },
        { code: 110301, name: 'T0N1M0', parentCode: 110300 },
        { code: 110302, name: 'T0N1M1', parentCode: 110300 },
        { code: 110400, name: 'N2', parentCode: 110000 },
        { code: 110401, name: 'T0N2M0', parentCode: 110400 },
        { code: 110402, name: 'T0N2M1', parentCode: 110400 },
        { code: 110500, name: 'N3', parentCode: 110000 },
        { code: 110501, name: 'T0N3M0', parentCode: 110500 },
        { code: 110502, name: 'T0N3M1', parentCode: 110500 },

        { code: 120000, name: 'Tis', parentCode: 0 },
        { code: 120100, name: 'NX', parentCode: 120000 },
        { code: 120101, name: 'TisNXM0', parentCode: 120100 },
        { code: 120102, name: 'TisNXM1', parentCode: 120100 },
        { code: 120200, name: 'N0', parentCode: 120000 },
        { code: 120201, name: 'TisN0M0', parentCode: 120200 },
        { code: 120202, name: 'TisN0M1', parentCode: 120200 },
        { code: 120300, name: 'N1', parentCode: 120000 },
        { code: 120301, name: 'TisN1M0', parentCode: 120300 },
        { code: 120302, name: 'TisN1M1', parentCode: 120300 },
        { code: 120400, name: 'N2', parentCode: 120000 },
        { code: 120401, name: 'TisN2M0', parentCode: 120400 },
        { code: 120402, name: 'TisN2M1', parentCode: 120400 },
        { code: 120500, name: 'N3', parentCode: 120000 },
        { code: 120501, name: 'TisN3M0', parentCode: 120500 },
        { code: 120502, name: 'TisN3M1', parentCode: 120500 },

        { code: 130000, name: 'T1', parentCode: 0 },
        { code: 130100, name: 'NX', parentCode: 130000 },
        { code: 130101, name: 'T1NXM0', parentCode: 130100 },
        { code: 130102, name: 'T1NXM1', parentCode: 130100 },
        { code: 130200, name: 'N0', parentCode: 130000 },
        { code: 130201, name: 'T1N0M0', parentCode: 130200 },
        { code: 130202, name: 'T1N0M1', parentCode: 130200 },
        { code: 130300, name: 'N1', parentCode: 130000 },
        { code: 130301, name: 'T1N1M0', parentCode: 130300 },
        { code: 130302, name: 'T1N1M1', parentCode: 130300 },
        { code: 130400, name: 'N2', parentCode: 130000 },
        { code: 130401, name: 'T1N2M0', parentCode: 130400 },
        { code: 130402, name: 'T1N2M1', parentCode: 130400 },
        { code: 130500, name: 'N3', parentCode: 130000 },
        { code: 130501, name: 'T1N3M0', parentCode: 130500 },
        { code: 130502, name: 'T1N3M1', parentCode: 130500 },

        { code: 140000, name: 'T2', parentCode: 0 },
        { code: 140100, name: 'NX', parentCode: 140000 },
        { code: 140101, name: 'T2NXM0', parentCode: 140100 },
        { code: 140102, name: 'T2NXM1', parentCode: 140100 },
        { code: 140200, name: 'N0', parentCode: 140000 },
        { code: 140201, name: 'T2N0M0', parentCode: 140200 },
        { code: 140202, name: 'T2N0M1', parentCode: 140200 },
        { code: 140300, name: 'N1', parentCode: 140000 },
        { code: 140301, name: 'T2N1M0', parentCode: 140300 },
        { code: 140302, name: 'T2N1M1', parentCode: 140300 },
        { code: 140400, name: 'N2', parentCode: 140000 },
        { code: 140401, name: 'T2N2M0', parentCode: 140400 },
        { code: 140402, name: 'T2N2M1', parentCode: 140400 },
        { code: 140500, name: 'N3', parentCode: 140000 },
        { code: 140501, name: 'T2N3M0', parentCode: 140500 },
        { code: 140502, name: 'T2N3M1', parentCode: 140500 },

        { code: 150000, name: 'T3', parentCode: 0 },
        { code: 150100, name: 'NX', parentCode: 150000 },
        { code: 150101, name: 'T3NXM0', parentCode: 150100 },
        { code: 150102, name: 'T3NXM1', parentCode: 150100 },
        { code: 150200, name: 'N0', parentCode: 150000 },
        { code: 150201, name: 'T3N0M0', parentCode: 150200 },
        { code: 150202, name: 'T3N0M1', parentCode: 150200 },
        { code: 150300, name: 'N1', parentCode: 150000 },
        { code: 150301, name: 'T3N1M0', parentCode: 150300 },
        { code: 150302, name: 'T3N1M1', parentCode: 150300 },
        { code: 150400, name: 'N2', parentCode: 150000 },
        { code: 150401, name: 'T3N2M0', parentCode: 150400 },
        { code: 150402, name: 'T3N2M1', parentCode: 150400 },
        { code: 150500, name: 'N3', parentCode: 150000 },
        { code: 150501, name: 'T3N3M0', parentCode: 150500 },
        { code: 150502, name: 'T3N3M1', parentCode: 150500 },

        { code: 160000, name: 'T4', parentCode: 0 },
        { code: 160100, name: 'NX', parentCode: 160000 },
        { code: 160101, name: 'T4NXM0', parentCode: 160100 },
        { code: 160102, name: 'T4NXM1', parentCode: 160100 },
        { code: 160200, name: 'N0', parentCode: 160000 },
        { code: 160201, name: 'T4N0M0', parentCode: 160200 },
        { code: 160202, name: 'T4N0M1', parentCode: 160200 },
        { code: 160300, name: 'N1', parentCode: 160000 },
        { code: 160301, name: 'T4N1M0', parentCode: 160300 },
        { code: 160302, name: 'T4N1M1', parentCode: 160300 },
        { code: 160400, name: 'N2', parentCode: 160000 },
        { code: 160401, name: 'T4N2M0', parentCode: 160400 },
        { code: 160402, name: 'T4N2M1', parentCode: 160400 },
        { code: 160500, name: 'N3', parentCode: 160000 },
        { code: 160501, name: 'T4N3M0', parentCode: 160500 },
        { code: 160502, name: 'T4N3M1', parentCode: 160500 }
      ],
      tnmTreeList: [],
      // 级联选择器的配置选项
      tnmProps: {
        expandTrigger: 'hover', // 次级菜单的展开方式
        emitPath: false, // 在选中节点改变时，是否返回由该节点所在的各级菜单的值所组成的数组，若设置 false，则只返回该节点的值
        value: 'code', // 指定选项的值为选项对象的某个属性值
        label: 'name', // 指定选项标签为选项对象的某个属性值
        children: 'children' // 指定选项的子选项为选项对象的某个属性值
      },
      tnmName: '', // TMN分期
      // 生活轨迹
      lifeTrack: '',
      allLifeTrack: [
        { code: 0, name: '未选择' },
        { code: 2, name: '3个地区以下' },
        { code: 1, name: '3个地区及以上' }
      ],
      // 第三方保险/互助投保情况
      thirdPartyInsurance: '',
      allThirdPartyInsurance: [
        { code: 0, name: '未选择' },
        { code: 2, name: '总保额小于100万' },
        { code: 1, name: '总保额大于100万（含）' }
      ],
      // 欺诈风险
      hiddenDiseaseHistory: '',
      allHiddenDiseaseHistory: [
        { code: 0, name: '未选择' },
        { code: 1, name: '存在隐瞒病史及体检情况、伪造病历资料、公证书等情况' },
        {
          code: 2,
          name: '不存在隐瞒病史及体检情况、伪造病历资料、公证书等情况'
        }
      ],
      // 职业
      riskAppend: '',
      allRiskAppend: [
        { code: 0, name: '未选择' },
        { code: 1, name: '会员/推荐人/家庭成员从事保险、公估、医护工作' },
        { code: 2, name: '并非从事保险、公估、医护工作' }
      ],
      // 事故类型
      accidentType: '',
      accidentTypeName: '',
      accidentTypeList: [],

      // 是否高风险运动、职业、作业
      isType: [
        { name: '请选择', code: -1 },
        { name: '是', code: 1 },
        { name: '否', code: 0 }
      ],
      // 高风险运动
      isRiskMovement: '',
      riskMovement: '',
      riskMovementRemark: '',
      riskMovementType: [
        { name: '请选择', code: 0 },
        { name: '潜水', code: 1 },
        { name: '滑水', code: 2 },
        { name: '滑雪', code: 3 },
        { name: '滑冰', code: 4 },
        { name: '驾驶或乘坐滑翔翼、滑翔伞', code: 5 },
        { name: '跳伞', code: 6 },
        { name: '攀岩运动', code: 7 },
        { name: '探险活动', code: 8 },
        { name: '武术比赛', code: 9 },
        { name: '摔跤比赛', code: 10 },
        { name: '柔道', code: 11 },
        { name: '空手道', code: 12 },
        { name: '跆拳道', code: 13 },
        { name: '马术', code: 14 },
        { name: '拳击', code: 15 },
        { name: '特技表演', code: 16 },
        { name: '驾驶卡丁车', code: 17 },
        { name: '赛马', code: 18 },
        { name: '赛车', code: 19 },
        { name: '各种车辆表演', code: 20 },
        { name: '蹦极', code: 21 },
        { name: '其他', code: 22 }
      ],
      // 高风险职业
      isRiskJob: '',
      riskJob: '',
      riskJobType: [
        { name: '请选择', code: 0 },
        {
          name:
            '从事建筑工程工作人员（包括但不限于建筑施工工人、建筑工程车辆驾驶或机械操作员、工地管理人员及临时工作人员）；',
          code: 1
        },
        {
          name: '涉及或接触任何危险物（化学物质、爆炸物、有毒物质等）的作业人员；',
          code: 2
        },
        { name: '从事煤炭生产、油矿开采业作业人员；', code: 3 },
        { name: '高压电或带电作业人员；', code: 4 },
        { name: '从事烟花爆竹生产、冶金、机械制造工作人员；', code: 5 },
        {
          name:
            '现役军警人员中的地面部队、海军陆战队、水兵、空军飞行员、前线军人、特种部队人员，或防爆警、刑警、消防队员、武器装备研制生产与试验（含民用航空及核燃料）人员；',
          code: 6
        },
        { name: '从事交通运输的驾驶员及随车辅助人员', code: 7 },
        { name: '从事高风险运动的运动员、教练员、陪练员', code: 8 },
        { name: '战地记者', code: 9 }
      ],
      // 高风险作业
      isRiskTask: '',
      riskTask: '',
      riskTaskRemark: '',
      riskTaskType: [
        { name: '请选择', code: 0 },
        { name: '设备检修作业', code: 1 },
        { name: '电气作业', code: 2 },
        { name: '热工作业', code: 3 },
        { name: '进入受限空间作业', code: 4 },
        { name: '挖掘作业', code: 5 },
        { name: '起重作业', code: 6 },
        { name: '高处作业', code: 7 },
        { name: '接触危险化学品作业', code: 8 }
      ],

      // 意外互助标准
      ywhzType: [],
      ywMutualStandard: '',

      // 日期选择器-快捷选项
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }
        ]
      }
    }
  },

  // 计算属性
  computed: {
    /**
     * 获取案件信息数据
     */
    ...mapState({
      caseInfo: (state) => state.caseDetail.caseInfo,
      permList: (state) => state.permission.permList
    }),

    /**
     * 判断当前权限的编辑状态
     */
    // eslint-disable-next-line vue/return-in-computed-property
    isEditStatus() {
      const {
        caseInfo: { productName },
        permList,
        checkPermission
      } = this

      if (productName.substring(0, 2) === '抗癌') {
        if (!checkPermission('初审:互助信息:可改', permList)) {
          return false
        } else if (checkPermission('初审:互助信息:可改', permList)) {
          return true
        }
      } else if (productName.substring(0, 2) === '意外') {
        if (!checkPermission('初审:意外互助信息:可改', permList)) {
          return false
        } else if (checkPermission('初审:意外互助信息:可改', permList)) {
          return true
        }
      }
    },

    /**
     * 判断案件类型（抗癌、意外）
     */
    // eslint-disable-next-line vue/return-in-computed-property
    isCaseType() {
      const {
        caseInfo: { productName }
      } = this

      if (productName.substring(0, 2) === '抗癌') {
        return true
      } else if (productName.substring(0, 2) === '意外') {
        return false
      }
    },

    /**
     * 计算超期报案的状态
     */
    areReported() {
      const {
        caseInfo: { productName, createTime },
        firstDiagnosisTime,
        memberDeathTime
      } = this
      let stateTxt = '未超期'

      if (createTime) {
        let nums = 0
        if (productName.substring(0, 2) === '抗癌' && firstDiagnosisTime) {
          nums = this._onCountingDays(createTime, firstDiagnosisTime)
          if (nums > 120) {
            stateTxt = `<span style="color: red">超期${nums - 120}天</span>`
          }
        } else if (productName.substring(0, 2) === '意外' && memberDeathTime) {
          nums = this._onCountingDays(createTime, memberDeathTime)
          if (nums > 15) {
            stateTxt = `<span style="color: red">超期${nums - 15}天</span>`
          }
        }
      }

      return stateTxt
    }
  },

  watch: {
    // 监听案件详情数据的变化
    caseInfo() {
      const {
        caseInfo: { caseCode }
      } = this
      if (caseCode) {
        this.onInitData()
      }
    }
  },

  mounted() {
    const {
      caseInfo: { caseCode }
    } = this
    if (caseCode) {
      this.onInitData() // 初始化页面数据
    }
  },

  methods: {

    ...mapActions({
      setCaseInfo: 'caseDetail/setCaseInfo'
    }),

    /**
     * 初始化页面数据
     */
    onInitData() {
      const _this = this
      const {
        caseInfo: {
          caseCode,
          diseaseIcdInfo,
          firstDiagnosisTime,
          symptomAppearanceTime,
          tnmName,
          lifeTrack,
          thirdPartyInsurance,
          riskAppend,
          accidentTime,
          memberDeathTime,
          hiddenDiseaseHistory,
          accidentType,
          accidentTypeName,
          isRiskMovement,
          riskMovement,
          riskMovementRemark,
          isRiskJob,
          riskJob,
          isRiskTask,
          riskTask,
          riskTaskRemark,
          ywMutualStandard
        },
        eventValue
      } = _this
      if (caseCode) {
        if (eventValue === 'cancerDiseaseInfo') {
          _this.icdName = diseaseIcdInfo.icdName // 疾病名称
          _this.icdCode = diseaseIcdInfo.icdCode ? diseaseIcdInfo.icdCode : '未选择' // ICD10
        } else if (eventValue === 'cancerTime') {
          _this.firstDiagnosisTime = firstDiagnosisTime // 确诊时间
          _this.symptomAppearanceTime = symptomAppearanceTime // 发病时间
        } else if (eventValue === 'accidentTime') {
          _this.accidentTime = accidentTime // 事故时间
          _this.memberDeathTime = memberDeathTime // 死亡时间
        } else if (eventValue === 'tnmInfo') {
          const newList = JSON.parse(JSON.stringify(_this.tnmList))
          const { tnmTreeList, tnmList } = _this

          // 遍历列表，查询对应TMN分级的“code”值
          if (tnmName) {
            tnmList &&
              tnmList.forEach((item) => {
                if (item.name == tnmName) _this.tnmName = item.code // TNM分期
              })
          }

          if (!tnmTreeList.length) {
            _this.tnmTreeList = _this.filterNull(
              _this.toTreeData(newList, 'parentCode', 'code')
            )
          }
        } else if (eventValue === 'lifeTrack') {
          _this.lifeTrack = lifeTrack // 生活轨迹
        } else if (eventValue === 'thirdPartyInsurance') {
          _this.thirdPartyInsurance = thirdPartyInsurance // 第三方保险/互助投保情况
        } else if (eventValue === 'hiddenDiseaseHistory') {
          _this.hiddenDiseaseHistory = hiddenDiseaseHistory // 欺诈风险
        } else if (eventValue === 'riskAppend') {
          _this.riskAppend = riskAppend // 职业
        } else if (eventValue === 'isRiskMovement') {
          // 是否高风险运动
          _this.isRiskMovement = isRiskMovement
          _this.riskMovement = riskMovement
          _this.riskMovementRemark = riskMovementRemark
        } else if (eventValue === 'isRiskJob') {
          // 是否高风险职业
          _this.isRiskJob = isRiskJob
          _this.riskJob = riskJob
        } else if (eventValue === 'isRiskTask') {
          // 是否高风险作业
          _this.isRiskTask = isRiskTask
          _this.riskTask = riskTask
          _this.riskTaskRemark = riskTaskRemark
        } else if (eventValue === 'ywMutualStandard') {
          // 意外互助标准
          _this.ywMutualStandard = ywMutualStandard
          _this.fetchYwhzTypeData()
        } else if (eventValue === 'accidentType') {
          const { accidentTypeList } = _this
          _this.accidentType = accidentType // 事故类型
          _this.accidentTypeName = accidentTypeName
          if (accidentTypeList && !accidentTypeList.length) {
            _this.getaccidentTypeList()
          }
        }
      }
    },

    /**
     * 获取意外互助类型选项数据
     */
    fetchYwhzTypeData() {
      const { isRiskMovement, isRiskJob, isRiskTask, ywMutualStandard } = this.caseInfo
      if (Number(isRiskMovement) === 1 || Number(isRiskJob) === 1 || Number(isRiskTask) === 1) {
        this.ywhzType = [{ code: 2, name: '高风险意外' }]
        this.ywMutualStandard = 2
        if (Number(ywMutualStandard) !== 2) {
          this.onChangeInputVal('ywMutualStandard', 2)
        }
      } else {
        // 因为选择了高风险运动、职业、作业，互助只能选高风险，所以this.ywhzType有可能会变化，初始化时要初始化一次this.ywhzType
        this.ywhzType = [
          { code: 0, name: '未选择' },
          { code: 1, name: '一般意外' },
          { code: 2, name: '高风险意外' }
        ]
      }
    },

    /**
     * 获取事故类型选项数据
     */
    async getaccidentTypeList() {
      const _this = this

      try {
        const { data: result } = await _this.axios.get(
          `/case/getAccidentTypeEnumList`
        )
        if (result && result.status === '000000') {
          const data = result.enums
          _this.accidentTypeList = data
        } else {
          _this.$alert(result && result.message, '提示')
        }
      } catch (error) {
        console.log('获取事故类型选项数据-请求失败', error)
      }
    },

    /**
     * 疾病名称-输入框查询匹配项
     * @param {string} queryString 查询关键词
     * @param {any} cb  回调函数
     */
    async querySearch_front(queryString, cb) {
      const _this = this
      try {
        const { data: result } = await this.axios.get(
          `/disease-icd/list-icd?icdName=${queryString}`
        )
        if (result && result.status === '000000') {
          const nginxServerData = result.data
          _this.nginxServerData = nginxServerData
          let restaurants = []
          // 我后端请求回来的数据是个数组放在了nginxServerData的
          restaurants =
            nginxServerData &&
            nginxServerData.map((items) => {
              // 因为列表框中的数据是必须要用value这个属性的 所以我这里做了处理
              return {
                value: items.icdName,
                code: items.icdCode
              }
            })

          // 调用 callback 返回建议列表的数据
          cb && cb(restaurants)
        } else {
          _this.$alert(result && result.message)
        }
      } catch (error) {
        console.log('输入框查询匹配数据-请求失败', error)
      }
    },

    /**
     * 诊断名称选择器-选中事件
     * @param {any} item 选中建议项
     */
    handleSelect(item) {
      const _this = this
      const { nginxServerData, caseInfo } = _this
      nginxServerData &&
        nginxServerData.forEach((i) => {
          if (item.code == i.icdCode) {
            _this.icdCode = i.icdCode
            _this.icdName = i.icdName
            _this.icdId = i.id

            const newCaseInfo = JSON.parse(JSON.stringify(caseInfo))
            if (newCaseInfo && newCaseInfo.diseaseIcdInfo) {
              newCaseInfo.diseaseIcdInfo.icdCode = i.icdCode
              newCaseInfo.diseaseIcdInfo.icdName = i.icdName
              newCaseInfo.diseaseIcdInfo.icdId = i.id
              newCaseInfo.diseaseIcdInfo.id = i.id
              newCaseInfo.diseaseIcdInfo.degreeType = i.degreeType
              newCaseInfo.diseaseIcdInfo.degreeTip = i.degreeTip

              _this.setCaseInfo(newCaseInfo)
              _this.caseHelpMoney()
            }
          }
        })
    },

    /**
     * 意外-事故类型选择器改变事件
     */
    accidentTypeChange(value) {
      const { caseInfo, accidentTypeList } = this
      let accidentTypeName = ''
      const newCaseInfo = JSON.parse(JSON.stringify(caseInfo))
      newCaseInfo.accidentType = value

      // 遍历事故类型，并查询选中项的“name”值
      accidentTypeList &&
        accidentTypeList.forEach((item) => {
          if (item.code == value) accidentTypeName = item.name
        })
      newCaseInfo.accidentTypeName = accidentTypeName

      this.setCaseInfo(newCaseInfo)
      this.caseHelpMoney()
    },

    /**
     * 查询最高互助金
     */
    async caseHelpMoney() {
      const _this = this
      const {
        caseInfo: {
          caseCode,
          diseaseIcdInfo,
          firstDiagnosisTime,
          kyMutualStandard,
          ywMutualStandard,
          accidentType,
          diseaseCode
        }
      } = _this
      // 如果当前ICD-10是少儿呼吸道，即不用单独计算最高互助金
      if (
        diseaseIcdInfo != undefined &&
        diseaseIcdInfo != null &&
        diseaseIcdInfo.degreeType == 1
      ) {
        return
      }

      var params = ''
      if (firstDiagnosisTime != undefined) {
        params += '&firstDiagnosisTime=' + firstDiagnosisTime
      }
      if (kyMutualStandard != undefined && kyMutualStandard != 0) {
        params += '&kyMutualStandard=' + kyMutualStandard
      }
      if (ywMutualStandard != undefined && ywMutualStandard != 0) {
        params += '&ywMutualStandard=' + ywMutualStandard
      }
      if (accidentType != undefined) {
        params += '&accidentType=' + accidentType
      }
      if (diseaseIcdInfo && diseaseIcdInfo.id != undefined) {
        params += '&icdId=' + diseaseIcdInfo.id
      }
      if (diseaseCode != undefined) {
        params += '&diseaseCode=' + diseaseCode
      }

      try {
        const { data: result } = await _this.axios.get(
          `/case/compute/caseHelpMoney?caseCode=${caseCode}${params}`
        )

        if (result && result.status === '000000') {
          const newResult = result.data
          const newCaseInfo = JSON.parse(JSON.stringify(_this.caseInfo))
          newCaseInfo.mutualMoney = newResult.helpMoney
          _this.setCaseInfo(newCaseInfo)
        } else {
          _this.$alert((result && result.message) || '服务器繁忙，请稍后重试', '提示')
        }
      } catch (error) {
        console.log('查询最高互助金-请求失败', error)
      }
    },

    /**
     * 监听TNM分期级联选择器值的变化
     * @param {string} value
     */
    onChangeTnmVal(val) {
      const _this = this
      const { tnmList } = _this

      if (val) {
        tnmList &&
          tnmList.forEach((item) => {
            if (item.code == val) {
              _this.onChangeInputVal('tnmName', item.name)
            }
          })
      }
    },

    /**
     * 监听输入框的变化
     * @param {string} key 键名
     * @param {string} value
     */
    onChangeInputVal(key, value) {
      this.$emit('changeEventData', key, value)
    },

    /**
     * 计算两个日期之间的相差天数
     * @param {string} date1 日期1（格式YYYY-MM-DD）
     * @param {string} date2 日期2（格式YYYY-MM-DD）
     */
    _onCountingDays(date1 = '', date2 = '') {
      const firstDate = new Date(date1) // 当天时间
      const secondDate = new Date(date2)
      const diff = firstDate.getTime() - secondDate.getTime()
      // const result = parseInt(diff / (1000 * 60 * 60 * 24))
      const result = parseInt(NP.divide(diff, NP.times(1000, 60, 60, 24)))
      return result
    }
  }
}
</script>

<style scoped lang="scss">
@import "./index.scss";
</style>
